import { api } from '@marketplace-web/core-api/core-api-client-data'

export const disableUserHoliday = (userId: number) => api.delete(`/users/${userId}/holiday`)
